import { Box, Stack, useBreakpointValue, useColorMode } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import StepCard from "../../../components/common/stepcard/stepcard";
import StepPath from "../../../components/common/steppath/steppath";

const ProcessFlow = () => {
    const fixedHeightForSecondAndFourth = 600;
    const { colorMode } = useColorMode();

    // const commonPath = useBreakpointValue({
    //     md: "M 0 50 C 0 300, 900 100, 480 810",
    // });

    // const commonPath1 = useBreakpointValue({
    //     md: "M 600 10 C 800 400, 100 100, 30 530", 
    // });

    const linePositions = {
        path1: useBreakpointValue({
            md: { top: "41%", left: "36%" },
        }),
        path2: useBreakpointValue({
            md: { top: "6%", left: "33.7%", height: fixedHeightForSecondAndFourth },
        }),
        path3: useBreakpointValue({
            md: { top: "42%", left: "36%" },
        }),
        path4: useBreakpointValue({
            md: { top: "6%", left: "34%", height: fixedHeightForSecondAndFourth },
        }),
        path5: useBreakpointValue({
            md: { top: "1800px", left: "40%" },
        }),
    };

    // Steps data array
    const steps = [
        {
            number: 1,
            title: "Discovery",
            highlight: "& Research",
            description: "We start by understanding your business, goals, and target audience. Through in-depth research and analysis, we uncover key insights that inform our strategy and ensure we're aligned with your vision.",
            isLeftAligned: true,
            imagePath: colorMode === "light" ? "/assets/images/svg/1white.svg" : "/assets/images/svg/1.svg",
            mobileImagePath: colorMode === "light" ? "/assets/images/svg/coin1mobilewhite.svg" : "/assets/images/svg/coin1mobile.svg",
            // path: commonPath,
            linePosition: linePositions.path1,
        },
        {
            number: 2,
            title: "Strategy",
            highlight: "Planning",
            description: "Based on our findings, we craft a tailored digital marketing strategy that outlines clear objectives, tactics, and timelines. This blueprint is designed to maximize your brand’s potential and achieve measurable growth.",
            isLeftAligned: false,
            imagePath: colorMode === "light" ? "/assets/images/svg/2white.svg" : "/assets/images/svg/2.svg",
            mobileImagePath: colorMode === "light" ? "/assets/images/svg/coin2mobilewhite.svg" : "/assets/images/svg/coin2mobile.svg",
            // path: commonPath1,
            linePosition: linePositions.path2,
        },
        {
            number: 3,
            title: "Execution",
            highlight: "Development",
            description: "Our team brings your strategy to life with compelling content, innovative campaigns, and eye-catching designs. We focus on delivering unique, high-quality outputs that resonate with your audience and drive engagement.",
            isLeftAligned: true,
            imagePath: colorMode === "light" ? "/assets/images/svg/3white.svg" : "/assets/images/svg/3.svg",
            mobileImagePath: colorMode === "light" ? "/assets/images/svg/coin3mobilewhite.svg" : "/assets/images/svg/coin3mobile.svg",
            // path: commonPath,
            linePosition: linePositions.path3,
        },
        {
            number: 4,
            title: "Launch",
            highlight: "Deployment",
            description: "As we implement your strategy, we continuously monitor performance and make data-driven adjustments. By optimizing in real-time, we ensure your campaigns stay effective and scalable as your business grows.",
            isLeftAligned: false,
            imagePath: colorMode === "light" ? "/assets/images/svg/4white.svg" : "/assets/images/svg/4.svg",
            mobileImagePath: colorMode === "light" ? "/assets/images/svg/coin4mobilewhite.svg" : "/assets/images/svg/coin4mobile.svg",
            // path: commonPath1,
            linePosition: linePositions.path4,
        },
        {
            number: 5,
            title: "Growth",
            highlight: "Optimization",
            description: "We provide transparent, detailed reports that show the impact of our work on your business. We also gather your feedback to refine our approach, ensuring ongoing improvement and success in your growth journey.",
            isLeftAligned: true,
            imagePath: colorMode === "light" ? "/assets/images/svg/5white.svg" : "/assets/images/svg/5.svg",
            mobileImagePath: colorMode === "light" ? "/assets/images/svg/coin5mobilewhite.svg" : "/assets/images/svg/coin5mobile.svg",
            path: "",
            linePosition: linePositions.path5,
        },
    ];

    const [boxHeight, setBoxHeight] = useState(0);
    const [lastScrollY, setLastScrollY] = useState<number>(0);
    const minHeight = 0;
    const maxHeight = 600;
    const scrollSpeed = 8;

    const isDesktop = useBreakpointValue({ base: false, md: true });

    useEffect(() => {
        if (!isDesktop) return;

        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            const isScrollingDown = currentScrollY > lastScrollY;

            setBoxHeight((prevHeight) => {
                if (isScrollingDown) {
                    return Math.min(prevHeight + scrollSpeed, maxHeight);
                } else {
                    return Math.max(prevHeight - scrollSpeed, minHeight);
                }
            });

            setLastScrollY(currentScrollY);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollY, isDesktop]);


    return (
        <Box w="full" position="relative" py={10} px={{ base: 4, md: 16 }} overflow="hidden">
            <Stack spacing={{ base: 12, md: 226 }} align="center" direction="column" py={10} px={6}>
                {steps.map((step, index) => (
                    <Box key={index + 1} position="relative">
                        {/* Step Card */}
                        <StepCard
                            number={step.number}
                            title={step.title}
                            highlight={step.highlight}
                            description={step.description}
                            isLeftAligned={step.isLeftAligned}
                            imagePath={step.imagePath}
                            mobileImagePath={step.mobileImagePath}
                        />
                        {step.path && isDesktop && (
                            <StepPath
                                pathData={step.path}
                                top={step?.linePosition?.top || "110%"}
                                left={step?.linePosition?.left || "110%"}
                                boxHeight={boxHeight}
                            />
                        )}
                    </Box>
                ))}
            </Stack>
        </Box>
    );
};

export default ProcessFlow;
